export const commonShadowStyles = {
  // apply using style attribute as TW doesn't support multiple shadows
  boxShadow:
    'inset 0px 0.8px 2px 0px rgba(0,0,0,0.15), 0px 0.8px 1px 1px rgba(0,0,0,0.15)',
}

export const commonInputStyles = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      // a previous junior developer added this, not really sure it does anything!
      borderColor: '#F4F4F4',
    },
    '&:hover fieldset': {
      borderColor: '#F4F4F4',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#F4F4F4',
    },
    minHeight: '40px',
    borderRadius: '8px',
    boxShadow:
      '0px 0.8px 2px 0px rgba(0, 0, 0, 0.15) inset, 0px 0.5px 2px 0px rgba(0, 0, 0, 0.25)',
    fontSize: '14px',
    fontWeight: 500,
    '& .MuiInputBase-input': {
      padding: '8px 10px',
    },
  },
}

export const commonSelectStyles = {
  borderRadius: '8px',
  boxShadow: '0px 0.8px 2px 0px rgba(0, 0, 0, 0.15) inset',
  '& .MuiSelect-select': {
    borderRadius: '8px',
    boxShadow: '0px 0.8px 1px 1px rgba(0,0,0,0.15)',
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0.4px',
    padding: '10px',
    color: '#37A2BA',
  },
  '& .MuiSvgIcon-root': {
    color: '#37A2BA',
    borderRadius: '8px',
  },
}

export const commonRadioStyles = {
  '&.Mui-checked': {
    color: '#020251',
  },
  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },
}

export const commonTextareaStyles =
  'w-full border-[#F4F4F4] appearance-none rounded-lg p-[4px_10px] pt-[16px] text-base focus:outline-none focus:border-[#37A2BA] focus:border'
